import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import CnjChart from "./chart";
import CnjFilter from "./filter";
import CnjTable from "./table";

const CnjAnalysis = ({ data, totalCnj }) => {
  const [state, setState] = useState({
    tribunais: [],
    localidades: [],
    esferas: [],
  });
  const [localidades, setLocalidades] = useState([]);

  useEffect(() => {
    if (state.tribunais.length > 0 || state.esferas.length > 0) {
      let arr = [];
      let i = 0;

      state.tribunais.map((tribunal) => {
        const t = data[tribunal];
        const e = state.esferas.length == 0 ? Object.keys(t) : state.esferas;

        e.map((esfera) => {
          if (esfera != "valores") {
            arr = arr.concat(
              Object.keys(t[esfera]).map((l, i) => {
                return { id: i++, nome: l, key: l };
              })
            );
          }
        });
      });

      setLocalidades(arr);
    }
  }, [state.tribunais, state.esferas]);

  const updateState = (key, arr) => setState({ ...state, [key]: arr });

  return (
    <div className="analysis-area">
      <CnjFilter
        data={data}
        state={state}
        localidades={localidades}
        updateState={updateState}
      />

      <Grid container spacing={2} style={{ padding: "0px" }}>
        <CnjTable data={data} state={state} totalCnj={totalCnj} />

        <CnjChart data={data} state={state} />
      </Grid>
    </div>
  );
};

export default CnjAnalysis;
